import { render, staticRenderFns } from "./ITTacceptOrReject.vue?vue&type=template&id=0028181e&scoped=true&"
import script from "./ITTacceptOrReject.vue?vue&type=script&lang=ts&"
export * from "./ITTacceptOrReject.vue?vue&type=script&lang=ts&"
import style0 from "./ITTacceptOrReject.vue?vue&type=style&index=0&id=0028181e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0028181e",
  null
  
)

export default component.exports